<script lang="ts">
	import { format } from 'svelte-i18n';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	import { round } from 'src/helpers/units_helpers';
	import { navigateToSetting } from 'src/stores/ui/navigate-to';
	//Components
	import WeatherStationCard from './WeatherStationCard.svelte';
	import type { SkyConditions, SkyConditionsInfo } from '../weather_station_cloud_helpers';
	//Icons
	import CloudLightIcon from './Icons/CloudLightIcon.svelte';
	import MoonStarsLight from './Icons/MoonStarsLight.svelte';
	import SunLight from './Icons/SunLight.svelte';
	import SunriseLight from './Icons/SunriseLight.svelte';
	import SunsetLight from './Icons/SunsetLight.svelte';
	import CloudSunLight from './Icons/CloudSunLight.svelte';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;
	export let skyInfo: SkyConditionsInfo;
	export let skyConditionLabel: SkyConditions | '';
	export let loading: boolean = false;
	export let setLocationAlert: boolean = false;
	export let disableSetLocationAlert: boolean = false;

	const sunConditionsLabels = {
		sunrise: $format('text_sunrise_at', { default: 'Sunrise at' }),
		sunset: $format('text_sunset_at', { default: 'Sunset at' }),
	};

	const skyConditions = {
		CLEAR: $format('weather_station_condition_clear', { default: 'Clear' }),
		PARTLY_CLOUDY: $format('weather_station_condition_partly_cloudy', {
			default: 'Partly cloudy',
		}),
		CLOUDY: $format('weather_station_condition_cloudy', { default: 'Cloudy' }),
		NIGHT: $format('weather_station_condition_night', { default: 'Night' }),
		DAWN: $format('weather_station_condition_dawn', {
			default: 'Dawn',
		}),
		DUSK: $format('weather_station_condition_dusk', {
			default: 'Dusk',
		}),
	};

	const skyConditionsIcons = {
		CLEAR: SunLight,
		PARTLY_CLOUDY: CloudSunLight,
		CLOUDY: CloudLightIcon,
		NIGHT: MoonStarsLight,
		DAWN: SunriseLight,
		DUSK: SunsetLight,
	};

	const gotoDeviceMap = () => {
		navigateToSetting(device.id, 'geo_location_and_elevation');
	};
</script>

<WeatherStationCard
	{loading}
	icon="fa-regular fa-cloud-sun header-icon"
	label={capFirstChar($format('title_sky_card', { default: 'Sky' }))}
	value={skyConditions[skyConditionLabel] || skyConditionLabel}
	description={skyInfo ? capFirstChar(sunConditionsLabels[skyInfo.nextSunState]) : ''}
	descriptionValue={skyInfo ? skyInfo.nextSunStateTime : ''}
	descriptionInOneRow={true}
	{setLocationAlert}
	{disableSetLocationAlert}
	setLocationAlertTitle={$format('alert_weather_station_set_location_sky_info', {
		default: 'Set your location to view sky conditions.',
	})}
	on:click
>
	<div slot="main">
		<svelte:component this={skyConditionsIcons[skyConditionLabel]} />
	</div>
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<div slot="info" style="cursor: pointer;" on:click={gotoDeviceMap}>
		<i class="fas fa-location-dot"></i>
		{skyInfo ? `${round(skyInfo.lat, 2)}° ${skyInfo.lat >= 0 ? 'N' : 'S'}` : '--'}
		{skyInfo ? `${round(skyInfo.lng, 2)}° ${skyInfo.lng >= 0 ? 'E' : 'W'}` : '--'}
	</div>
</WeatherStationCard>
